import cn from "date-fns/locale/zh-CN";
import moment from "moment";
import { forwardRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import { addSXWYYearRequest } from "../../../api/adminApi";
import { getSXWYShengxiaoNianMapping, getSXWYYear } from "../../../api/userApi";
import { dispatchAlertError, dispatchAlertSuc } from "../../../app/godispatch";
import { PRIVILEGE_ADMIN } from "../../../app/privileges";
import { selectUserPrivileges } from "../../../app/user/userSlice";
import Loading from "../../component/Loading";
import RoleLayout from "../../component/RoleLayout";
import './SXWYPage.css';

const shengxiaoArr = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];
const ganzhiArr = [
    ['甲子', '丙子', '戊子', '庚子', '壬子'],
    ['乙丑', '丁丑', '己丑', '辛丑', '癸丑'],
    ['丙寅', '戊寅', '庚寅', '壬寅', '甲寅'],
    ['丁卯', '己卯', '辛卯', '癸卯', '乙卯'],
    ['戊辰', '庚辰', '壬辰', '甲辰', '丙辰'],
    ['己巳', '辛巳', '癸巳', '乙巳', '丁巳'],
    ['庚午', '壬午', '甲午', '丙午', '戊午'],
    ['辛未', '癸未', '乙未', '丁未', '己未'],
    ['壬申', '甲申', '丙申', '戊申', '庚申'],
    ['癸酉', '乙酉', '丁酉', '己酉', '辛酉'],
    ['甲戌', '丙戌', '戊戌', '庚戌', '壬戌'],
    ['乙亥', '丁亥', '己亥', '辛亥', '癸亥'],
]

export default function SXWYPage() {
    document.title = '十二生肖密码 年份'
    const [loading, setLoading] = useState(false)
    const [nowDate, setNowDate] = useState(moment().toDate())
    const [shengxiao, setShengxiao] = useState(-1)
    const [ganzhi, setGanzhi] = useState(-1)
    const [detail, setDetail] = useState([])
    const hadPrivileges = useSelector(selectUserPrivileges)
    var shengxiaoNian = [
        [], [], [], [], [], [], [], [], [], [], [], []
    ]
    const [sxn, setsxn] = useState(shengxiaoNian)
    const [sxnDetail, setsxnDetail] = useState('')
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <Button variant="outline-info" className="choosedate" onClick={onClick} ref={ref} disabled={loading}>
            {value ? value : '请点击选择'}
        </Button>
    ));

    const chooseShengxiao = (index) => {
        if (loading) return
        setLoading(true)
        setGanzhi(-1)
        setsxnDetail('')
        setDetail([])
        if (hadPrivileges.includes(PRIVILEGE_ADMIN) || !sxn[index].length > 0) {
            getSXWYShengxiaoNianMapping(ganzhiArr[index])
                .then(res => {
                    shengxiaoNian = sxn;
                    shengxiaoNian[index] = res.data;
                    setsxn(shengxiaoNian)
                })
                .catch(e => {
                    console.log('getSXWYShengxiaoNianMapping' + e.message)
                })
                .finally(() => {
                    setShengxiao(index);
                    setLoading(false)
                })
        } else {
            setShengxiao(index);
            setLoading(false)
        }
    }

    const chooseGanzhi = (index) => {
        if (loading) return
        setGanzhi(index)
        setsxnDetail(sxn[shengxiao][index])
        setDetail([])
        search(index)
    }

    const search = (ganzhi) => {
        setLoading(true)
        getSXWYYear(moment(nowDate).format('YYYY'), ganzhiArr[shengxiao][ganzhi])
            .then(res => {
                if (hadPrivileges.includes(PRIVILEGE_ADMIN)) {
                    adminSetDetail(res.data.description)
                } else {
                    setDetail(res.data.description.split('\n'))
                }
            })
            .catch(e => {
                setDetail(['无结果'])
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const update = () => {
        setLoading(true)
        addSXWYYearRequest({
            nowYear: moment(nowDate).format('YYYY'),
            shengxiao: shengxiaoArr[shengxiao],
            shengxiaoNian: sxnDetail,
            year: ganzhiArr[shengxiao][ganzhi],
            month: null,
            description: detail.join()
        })
            .then(() => {
                dispatchAlertSuc('添加成功')
            })
            .catch((err) => {
                dispatchAlertError(err.message || '添加失败请稍后再试')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const adminSetDetail = (value) => {
        value = value.replaceAll('\\n', '&#13;&#10;');
        setDetail([value])
    }

    return (
        <RoleLayout>
            <Container className="sxwyBackground">
                <Row>
                    <Col xs={3} className='textBig g-0 d-flex justify-content-end'>
                        {hadPrivileges.includes(PRIVILEGE_ADMIN) &&
                            <DatePicker selected={nowDate}
                                onChange={(date) => {
                                    setShengxiao(-1)
                                    setGanzhi(-1)
                                    setsxnDetail('')
                                    setDetail([])
                                    setNowDate(date)
                                }}
                                showYearPicker
                                dateFormat="yyyy"
                                customInput={<ExampleCustomInput />}
                                locale={cn} />
                        }
                        {!hadPrivileges.includes(PRIVILEGE_ADMIN) &&
                            moment(nowDate).format('YYYY')
                        }
                    </Col>
                    <Col className='textBig g-0 d-flex justify-content-start'>
                        <span>年旺运【仅供参考】</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>选择您的生肖属相</h2>
                    </Col>
                </Row>
                <Row className="marginLine">
                    {shengxiaoArr.map((i, index) => {
                        if (shengxiao >= 0 && index === shengxiao) {
                            return <Col key={index} xs={3} className='d-flex justify-content-center align-items-center'>
                                <div className="choosedBlock d-flex justify-content-center align-items-center"
                                    onClick={() => chooseShengxiao(index)} >
                                    <span>{i}</span>
                                </div>
                            </Col>
                        } else {
                            return <Col key={index} xs={3} className='d-flex justify-content-center align-items-center'>
                                <div className="chooseBlock d-flex justify-content-center align-items-center"
                                    onClick={() => chooseShengxiao(index)} >
                                    <span>{i}</span>
                                </div>
                            </Col>
                        }
                    }
                    )}
                </Row>
                <Row className="marginLine">
                    {!loading && shengxiao >= 0 &&
                        <Col>
                            <h2>选择您的生肖年干支</h2>
                        </Col>
                    }
                </Row>
                <Row xs={5} className="marginLine">
                    {loading && <Loading />}
                    {!loading && shengxiao >= 0 &&
                        ganzhiArr[shengxiao].map((i, index) => {
                            if (ganzhi >= 0 && ganzhi === index) {
                                return <Col key={index} className='d-flex justify-content-center align-items-center'>
                                    <div className="choosedBlock" onClick={() => chooseGanzhi(index)}>
                                        <Row>
                                            <Col className="d-flex justify-content-center align-items-center">
                                                <span>{i}</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span>{sxn[shengxiao].length > 0 ? sxn[shengxiao][index] : ''}</span>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            } else {
                                return <Col key={index} className='d-flex justify-content-center align-items-center'>
                                    <div className="chooseBlock" onClick={() => chooseGanzhi(index)}>
                                        <Row>
                                            <Col className="d-flex justify-content-center align-items-center">
                                                <span>{i}</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span>{sxn[shengxiao].length > 0 ? sxn[shengxiao][index] : ''}</span>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            }
                        }
                        )}
                </Row>
                <Row>
                    <Col className='textBig d-flex justify-content-center align-items-center'>
                        {shengxiao >= 0 && <span>生肖为 {shengxiaoArr[shengxiao]}，</span>}
                        {ganzhi >= 0 && <span>干支为 {ganzhiArr[shengxiao][ganzhi]} </span>}
                    </Col>
                </Row>
                {hadPrivileges.includes(PRIVILEGE_ADMIN) &&
                    <>
                        <Row>
                            <Col>
                                <span>干支对应年份</span>
                                <Form.Control type="text"
                                    value={sxnDetail}
                                    onChange={(e) => setsxnDetail(e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>旺运技巧</span>
                                <Form.Control as="textarea" rows={5}
                                    value={detail}
                                    onChange={(e) => adminSetDetail(e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <Button variant="primary" onClick={update} disabled={loading}>确认修改</Button>
                            </Col>
                        </Row>
                    </>
                }
                {!hadPrivileges.includes(PRIVILEGE_ADMIN) && detail.length > 0 &&
                    <div className="resultBlock">
                        {detail.map((line, index) => {
                            return <Row key={index}>
                                <Col className='d-flex justify-content-center align-items-center'>
                                    {line}
                                </Col>
                            </Row>
                        })}
                    </div>
                }
            </Container>
        </RoleLayout>
    )
}